// ESM-Huelle um lib/scripts/pos/CLS_CThresholdPrice.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.
function CThresholdPrice(currentEntries, currentBonId)
{
    this.bonId = currentBonId;
    this.entries = currentEntries;

    this.shortVersionMax = 100;
    this.shortVersionJump = 1.5;
    this.shortVersionStep = 10;
}

CThresholdPrice.prototype.getThresholdPricesSV = function()
{
    var thresholdValues = new Array();

    for (var i = 0; i < this.shortVersionMax; i += this.shortVersionStep)
    {
        thresholdValues.push(i);
    }

    return thresholdValues;
}

CThresholdPrice.prototype.checkThresholdPriceSV = function(prices, amount)
{
    for (var i = 0; i < prices.length; i++)
    {
        if (amount >= prices[i] && amount <= prices[i] + this.shortVersionJump)
            return prices[i];
    }

    return null;
}

CThresholdPrice.prototype.getThresholdPrices = function(sum)
{
    /*privMan.enablePrivilege (privList);*/

    var results = new Array("price", "threshold");
    results.price = new Array();
    results.threshold = new Array();

    var sql = "SELECT Price, Threshold FROM THRPR WHERE Price < " + sum +
        "ORDER BY Price DESC LIMIT 2";

    var r = POS.SQLiteCon.execute(sql);
$.when(r).then(function(rows) {
    //if (r.recordCount())
			if (rows.length>0)
			{
				results.price[0] = parseFloat(rows[0].Price);
				results.threshold[0] = parseFloat(rows[0].Threshold);
			}
			/*else
				r.free();
		*/
			var sql = "SELECT Price, Threshold FROM THRPR WHERE Price > " + sum +
				"ORDER BY Price ASC LIMIT 3";

			var r = POS.SQLiteCon.execute(sql);
	$.when(r).then(function(rows2) {
			for (var i = 0; i < rows2.length; i++)
			{
				results.price[i + 1] = parseFloat(rows2[i].Price);
				results.threshold[i + 1] = parseFloat(rows2[i].Threshold);

				//r.moveNext();
			}

			//r.free();
			dfd.resolve(results);
			//return results;
	});
	});
}

CThresholdPrice.prototype.getImprovement = function(prices, currentPrice)
{
    var parameters = new Array();
    var order = new Array(2, 1, 3, 0, 4);

    for (var i = 0; i < order.length; i++)
    {
        if (typeof prices.price[order[i]] != "undefined")
        {
            var parameters = this.checkThresholdPrice(prices.price[order[i]],
                prices.threshold[order[i]], currentPrice);
            if (typeof parameters.newPrice != "undefined")
                break;
        }
    }

    return parameters;
}

CThresholdPrice.prototype.checkThresholdPrice = function(price, threshold, currentPrice)
{
    var parameters = new Array("newPrice", "entry", "action");

    if (fix2Decimals(Math.abs(currentPrice - price)) <= threshold)
    {
        parameters.newPrice = price;
        return parameters;
    }

    for (var i in this.entries)
    {
        if (!this.entries[i].cancelled && this.entries[i].type == "POS")
        {
            if (fix2Decimals(Math.abs(currentPrice + this.entries[i].unitAmount - price))
                <= threshold)
            {
                parameters.newPrice = price;
                parameters.entry = this.entries[i];
                parameters.action = "+";
            }
            else if (fix2Decimals(Math.abs(currentPrice - this.entries[i].unitAmount - price))
                <= threshold)
            {
                parameters.newPrice = price;
                parameters.entry = this.entries[i];
                parameters.action = "-";
            }
        }
    }

    return parameters;
}
export { CThresholdPrice };
